import { Link } from "@inertiajs/react";
import EditionOwnButton from "components/userBook/EditionOwnButton";
import CoverImage from "components/Cover/CoverImage";
import ReportEditionButton from "components/ReportDropdown/ReportEditionButton";
import TextLink from "hardcover-ui/components/TextLink";
import ReadingFormatIcon from "components/shared/ReadingFormatIcon";
import generateEditionData from "./generateEditionData";
import BookData from "./BookData";
import { EditionSerializersEdition, PageSerializersBooksLayout } from "types/serializers";
import ContributionsList from "components/authors/ContributionsList";

interface Props {
  book: PageSerializersBooksLayout;
  edition?: EditionSerializersEdition;
}

export default function BookEdition({ book, edition }: Props) {
  const data = generateEditionData(edition);

  return (
    <div className="relative flex flex-row items-start py-4 space-x-3 text-gray-600 dark:text-gray-200">
      <CoverImage
        image={edition.image}
        size="sm"
        title={edition.title || book.title}
        id={edition.id}
        settings={{
          stretch: "x",
        }}
      />

      <div className="flex flex-grow flex-col justify-center px-2">
        <p className="font-semibold leading-tight">
          <Link
            href={`/books/${book.slug}/editions/${edition.id}`}
            className="underline hover:no-underline"
          >
            {edition.title}
          </Link>
        </p>

        <div className="py-2 flex flex-row justify-between items-start">
          <div>
            {edition.publisher ? (
              <p>
                <span className="font-bold">Publisher: </span>
                <TextLink href={`/publishers/${edition.publisher.slug}`}>
                  {edition.publisher.name}
                </TextLink>
              </p>
            ) : (
              false
            )}
            <ContributionsList contributions={edition.contributions} max={8} expand byLine primary={false} />
            {data.map((dataPair) => (
              <BookData bookDataPair={dataPair} key={dataPair.title} />
            ))}

            <div className="mt-4 space-x-2 flex flex-row">
              <EditionOwnButton edition={edition} />
              <ReportEditionButton edition={edition} book={book} />
            </div>
          </div>
          {edition.readingFormatId && (
            <ReadingFormatIcon readingFormatId={edition.readingFormatId} />
          )}
        </div>
      </div>
    </div>
  );
}
